import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import viewStatuses from '../../../viewStatus.js';
import { trackEvent } from '../../../../services/trackingService';
import Page from '../../../page.jsx';
import { viewStatus as viewStatusPropType } from '../../../safeTradePropTypes.js';
import { forceRefresh } from '../../payment/paymentActions.js';
import orderIdFromUrlService from './orderIdFromUrlService.js';

function isOutOfSync(viewStatus) {
    return viewStatus !== viewStatuses.PAID;
}

class PaymentCompletedDetails extends PureComponent {
    componentDidMount() {
        trackEvent('trade.buyer-pays.buyer-completes-payment', 'success');

        const { viewStatus } = this.props;
        const orderId = orderIdFromUrlService();
        if (isOutOfSync(viewStatus) && orderId) {
            this.props
                .onOutOfSync(orderId)
                .catch(() => {})
                .then(() => {
                    this.props.router.replace('/');
                    window.location.reload();
                });
        } else {
            this.props.router.replace('/samtale');
        }
    }

    render() {
        return (
            <Page heading="Betaling vellykket">
                <div className="spinner mvs" />
            </Page>
        );
    }
}

PaymentCompletedDetails.propTypes = {
    onOutOfSync: PropTypes.func.isRequired,
    router: PropTypes.object.isRequired,
    viewStatus: viewStatusPropType.isRequired,
};

function mapStateToProps(state) {
    return {
        viewStatus: state.safeTrade.viewStatus,
    };
}

const mapDispatchToProps = { onOutOfSync: forceRefresh };

export default connect(mapStateToProps, mapDispatchToProps)(
    withRouter(PaymentCompletedDetails)
);



// WEBPACK FOOTER //
// ./safeTrade/buyer/payment/statusDetails/paymentCompletedDetails.jsx